import { useAuth } from "./useAuth";

/**
 * usePlan — convenience wrapper over useAuth that exposes the user's plan and
 * the free-tier limits the UI needs to render counters / gates. Mirrors the
 * server-side LIMITS in apps/api-ts/src/lib/plan.ts ; keep the two in sync.
 */

export const FREE_LIMITS = {
  maxFollows: 3,
  historyDays: 7,
} as const;

// Public pricing shown in the UI. The actual amounts come from Stripe Prices ;
// these are the display strings only. Keep in sync with the Stripe Prices
// (currently 5 €/mois, 39 €/an — EUR).
export const PRICING = {
  monthly: { amount: "5 €", period: "mois", note: "sans engagement, résiliable à tout moment" },
  yearly: { amount: "39 €", period: "an", note: "2 mois offerts vs mensuel" },
} as const;

export function usePlan() {
  const { user, isAuthenticated, isLoading } = useAuth();
  const plan = user?.plan ?? "free";
  const isPro = plan === "pro";
  return {
    plan,
    isPro,
    isFree: !isPro,
    isAuthenticated,
    isLoading,
    planStatus: user?.plan_status ?? null,
    planRenewsAt: user?.plan_renews_at ?? null,
  };
}
